"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PriceMessage = exports.SubscriptionTerm = exports.RightCurrency = exports.FractionalValue = exports.LeftCurrency = exports.PriceValueContainer = exports.SubsScriptPriceContainer = exports.OffScreenPrice = exports.PriceDetails = exports.PercentSavings = exports.PriceSpan = exports.PriceContainer = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const monera_app_core_1 = require("@amzn/monera-app-core");
const themed_text_1 = require("../themed-text");
const desktopPriceTypography = {
    savings: {
        doubleLarge: Object.assign(Object.assign({}, monera_app_core_1.commonFontAttributes), { fontSize: '28px', lineHeight: '36px', fontWeight: '300' }),
        extraLarge: Object.assign(Object.assign({}, monera_app_core_1.commonFontAttributes), { fontSize: '24px', lineHeight: '32px', fontWeight: '300' }),
        large: Object.assign(Object.assign({}, monera_app_core_1.commonFontAttributes), { fontSize: '20px', lineHeight: '28px', fontWeight: '300' }),
        mediumPlus: Object.assign(Object.assign({}, monera_app_core_1.commonFontAttributes), { fontSize: '18px', lineHeight: '24px', fontWeight: '300' }),
        medium: Object.assign(Object.assign({}, monera_app_core_1.commonFontAttributes), { fontSize: '15px', lineHeight: '21px' }),
        basePlus: Object.assign(Object.assign({}, monera_app_core_1.commonFontAttributes), { fontSize: '14px', lineHeight: '20px' }),
        base: Object.assign(Object.assign({}, monera_app_core_1.commonFontAttributes), { fontSize: '14px', lineHeight: '20px' }),
        small: Object.assign(Object.assign({}, monera_app_core_1.commonFontAttributes), { fontSize: '12px', lineHeight: '16px' }),
        mini: Object.assign(Object.assign({}, monera_app_core_1.commonFontAttributes), { fontSize: '12px', lineHeight: '16px' }),
        micro: Object.assign(Object.assign({}, monera_app_core_1.commonFontAttributes), { fontSize: '10px', lineHeight: '16px' })
    },
    subsTerm: {
        micro: Object.assign(Object.assign({}, monera_app_core_1.commonFontAttributes), { fontSize: '10px', lineHeight: '1.6' }),
        small: Object.assign(Object.assign({}, monera_app_core_1.commonFontAttributes), { fontSize: '10px', lineHeight: '1.6' }),
        mini: Object.assign(Object.assign({}, monera_app_core_1.commonFontAttributes), { fontSize: '10px', lineHeight: '1.6' }),
        base: Object.assign(Object.assign({}, monera_app_core_1.commonFontAttributes), { fontSize: '10px', lineHeight: '1.6' }),
        basePlus: Object.assign(Object.assign({}, monera_app_core_1.commonFontAttributes), { fontSize: '10px', lineHeight: '1.6' }),
        medium: Object.assign(Object.assign({}, monera_app_core_1.commonFontAttributes), { fontSize: '14px', lineHeight: '20px' }),
        mediumPlus: Object.assign(Object.assign({}, monera_app_core_1.commonFontAttributes), { fontSize: '14px', lineHeight: '20px' }),
        large: Object.assign(Object.assign({}, monera_app_core_1.commonFontAttributes), { fontSize: '14px', lineHeight: '20px' }),
        extraLarge: Object.assign(Object.assign({}, monera_app_core_1.commonFontAttributes), { fontSize: '14px', lineHeight: '20px' }),
        doubleLarge: Object.assign(Object.assign({}, monera_app_core_1.commonFontAttributes), { fontSize: '24px', lineHeight: '32px' })
    },
    priceDetails: {
        micro: Object.assign(Object.assign({}, monera_app_core_1.commonFontAttributes), { fontSize: '10px', lineHeight: '1.6' }),
        small: Object.assign(Object.assign({}, monera_app_core_1.commonFontAttributes), { fontSize: '10px', lineHeight: '1.6' }),
        mini: Object.assign(Object.assign({}, monera_app_core_1.commonFontAttributes), { fontSize: '10px', lineHeight: '1.6' }),
        base: Object.assign(Object.assign({}, monera_app_core_1.commonFontAttributes), { fontSize: '10px', lineHeight: '1.6' }),
        basePlus: Object.assign(Object.assign({}, monera_app_core_1.commonFontAttributes), { fontSize: '10px', lineHeight: '1.6' }),
        medium: Object.assign(Object.assign({}, monera_app_core_1.commonFontAttributes), { fontSize: '12px', lineHeight: '16px' }),
        mediumPlus: Object.assign(Object.assign({}, monera_app_core_1.commonFontAttributes), { fontSize: '12px', lineHeight: '16px' }),
        large: Object.assign(Object.assign({}, monera_app_core_1.commonFontAttributes), { fontSize: '14px', lineHeight: '20px' }),
        extraLarge: Object.assign(Object.assign({}, monera_app_core_1.commonFontAttributes), { fontSize: '14px', lineHeight: '20px' }),
        doubleLarge: Object.assign(Object.assign({}, monera_app_core_1.commonFontAttributes), { fontSize: '14px', lineHeight: '20px' })
    }
};
const mobilePriceTypogragraphy = {
    savings: {
        micro: Object.assign(Object.assign({}, monera_app_core_1.commonFontAttributes), { fontSize: '1.1rem', lineHeight: '1.6rem' }),
        mini: Object.assign(Object.assign({}, monera_app_core_1.commonFontAttributes), { fontSize: '1.1rem', lineHeight: '1.6rem' }),
        small: Object.assign(Object.assign({}, monera_app_core_1.commonFontAttributes), { fontSize: '1.3rem', lineHeight: '1.8rem' }),
        base: Object.assign(Object.assign({}, monera_app_core_1.commonFontAttributes), { fontSize: '1.5rem', lineHeight: '2.0rem' }),
        basePlus: Object.assign(Object.assign({}, monera_app_core_1.commonFontAttributes), { fontSize: '1.5rem', lineHeight: '2.0rem' }),
        medium: Object.assign(Object.assign({}, monera_app_core_1.commonFontAttributes), { fontSize: '1.8rem', lineHeight: '2.2rem' }),
        mediumPlus: Object.assign(Object.assign({}, monera_app_core_1.commonFontAttributes), { fontSize: '1.8rem', lineHeight: '2.2rem', fontWeight: '300' }),
        large: Object.assign(Object.assign({}, monera_app_core_1.commonFontAttributes), { fontSize: '2.0rem', lineHeight: '2.8rem', fontWeight: '300' }),
        extraLarge: Object.assign(Object.assign({}, monera_app_core_1.commonFontAttributes), { fontSize: '2.2rem', lineHeight: '2.8rem', fontWeight: '300' }),
        doubleLarge: Object.assign(Object.assign({}, monera_app_core_1.commonFontAttributes), { fontSize: '3.6rem', lineHeight: '4.4rem', fontWeight: '300' })
    },
    subsTerm: {
        micro: Object.assign(Object.assign({}, monera_app_core_1.commonFontAttributes), { fontSize: '1.0rem', lineHeight: '1.6' }),
        small: Object.assign(Object.assign({}, monera_app_core_1.commonFontAttributes), { fontSize: '1.0rem', lineHeight: '1.6' }),
        mini: Object.assign(Object.assign({}, monera_app_core_1.commonFontAttributes), { fontSize: '1.0rem', lineHeight: '1.6' }),
        base: Object.assign(Object.assign({}, monera_app_core_1.commonFontAttributes), { fontSize: '1.0rem', lineHeight: '1.6' }),
        basePlus: Object.assign(Object.assign({}, monera_app_core_1.commonFontAttributes), { fontSize: '1.0rem', lineHeight: '1.6' }),
        medium: Object.assign(Object.assign({}, monera_app_core_1.commonFontAttributes), { fontSize: '1.5rem', lineHeight: '1.35' }),
        mediumPlus: Object.assign(Object.assign({}, monera_app_core_1.commonFontAttributes), { fontSize: '1.5rem', lineHeight: '1.35' }),
        large: Object.assign(Object.assign({}, monera_app_core_1.commonFontAttributes), { fontSize: '1.5rem', lineHeight: '1.35' }),
        extraLarge: Object.assign(Object.assign({}, monera_app_core_1.commonFontAttributes), { fontSize: '1.5rem', lineHeight: '1.35' }),
        doubleLarge: Object.assign(Object.assign({}, monera_app_core_1.commonFontAttributes), { fontSize: '2.2rem', lineHeight: '1.3' })
    },
    priceDetails: {
        micro: Object.assign(Object.assign({}, monera_app_core_1.commonFontAttributes), { fontSize: '1.0rem', lineHeight: '1.6' }),
        small: Object.assign(Object.assign({}, monera_app_core_1.commonFontAttributes), { fontSize: '1.0rem', lineHeight: '1.6' }),
        mini: Object.assign(Object.assign({}, monera_app_core_1.commonFontAttributes), { fontSize: '1.0rem', lineHeight: '1.6' }),
        base: Object.assign(Object.assign({}, monera_app_core_1.commonFontAttributes), { fontSize: '1.0rem', lineHeight: '1.6' }),
        basePlus: Object.assign(Object.assign({}, monera_app_core_1.commonFontAttributes), { fontSize: '1.0rem', lineHeight: '1.6' }),
        medium: Object.assign(Object.assign({}, monera_app_core_1.commonFontAttributes), { fontSize: '1.3rem', lineHeight: '1.38' }),
        mediumPlus: Object.assign(Object.assign({}, monera_app_core_1.commonFontAttributes), { fontSize: '1.3rem', lineHeight: '1.38' }),
        large: Object.assign(Object.assign({}, monera_app_core_1.commonFontAttributes), { fontSize: '1.5rem', lineHeight: '1.35' }),
        extraLarge: Object.assign(Object.assign({}, monera_app_core_1.commonFontAttributes), { fontSize: '1.5rem', lineHeight: '1.35' }),
        doubleLarge: Object.assign(Object.assign({}, monera_app_core_1.commonFontAttributes), { fontSize: '1.5rem', lineHeight: '1.35' })
    }
};
const desktopRelativePositionMap = {
    micro: {},
    small: {},
    mini: {},
    base: {},
    basePlus: {
        top: '-3px',
        fontSize: '10px',
        lineHeight: '1.6'
    },
    medium: {
        top: '-3.5px',
        fontSize: '11px'
    },
    mediumPlus: {
        top: '-6px',
        fontSize: '10px',
        lineHeight: '16px'
    },
    large: {
        top: '-6.5px',
        fontSize: '12px'
    },
    extraLarge: {
        top: '-10px',
        fontSize: '13px'
    },
    doubleLarge: {
        top: '-15.5px',
        fontSize: '13px'
    }
};
const mobileRelativePositionMap = {
    micro: {},
    small: {},
    mini: {},
    base: {},
    basePlus: {
        top: '-0.35rem',
        fontSize: '10px',
        lineHeight: '1.6'
    },
    medium: {
        top: '-0.4rem',
        fontSize: '11px'
    },
    mediumPlus: {
        top: '-0.6rem',
        fontSize: '10px',
        lineHeight: '16px'
    },
    large: {
        top: '-0.8rem',
        fontSize: '12px'
    },
    extraLarge: {
        top: '-0.7rem',
        fontSize: '13px'
    },
    doubleLarge: {
        top: '-1.4rem',
        fontSize: '13px'
    }
};
const setRelativePosition = (props) => {
    let relativePositionMap = desktopRelativePositionMap;
    switch (props.deviceType) {
        case monera_app_core_1.DeviceType.Mobile:
        case monera_app_core_1.DeviceType.MShop:
            relativePositionMap = mobileRelativePositionMap;
            break;
        case monera_app_core_1.DeviceType.Tablet:
        case monera_app_core_1.DeviceType.Desktop:
        default:
            relativePositionMap = desktopRelativePositionMap;
    }
    return (0, styled_components_1.css)(Object.assign({}, relativePositionMap[props.size || 'base']));
};
const setSubscriptionTermStyle = (props) => {
    const typographyMap = props.deviceType === monera_app_core_1.DeviceType.Mobile || props.deviceType === monera_app_core_1.DeviceType.MShop
        ? mobilePriceTypogragraphy.subsTerm
        : desktopPriceTypography.subsTerm;
    const typography = typographyMap['large'];
    return (0, styled_components_1.css)({
        fontFamily: typography.fontFamily,
        fontStyle: typography.fontStyle,
        fontSize: typography.fontSize,
        fontWeight: typography.fontWeight,
        lineHeight: typography.lineHeight
    });
};
const setPriceMessageStyle = (props) => {
    const typographyMap = props.deviceType === monera_app_core_1.DeviceType.Mobile || props.deviceType === monera_app_core_1.DeviceType.MShop
        ? mobilePriceTypogragraphy.subsTerm
        : desktopPriceTypography.subsTerm;
    const typography = typographyMap['large'];
    return (0, styled_components_1.css)({
        fontFamily: typography.fontFamily,
        fontStyle: typography.fontStyle,
        fontSize: typography.fontSize,
        fontWeight: typography.fontWeight,
        lineHeight: typography.lineHeight
    });
};
const setContainerHeight = (props) => {
    const typography = props.theme.typography[props.size || 'base'];
    return (0, styled_components_1.css)({
        height: typography.lineHeight
    });
};
const setSavingsTypography = (props) => {
    const typographyMap = props.deviceType === monera_app_core_1.DeviceType.Mobile || props.deviceType === monera_app_core_1.DeviceType.MShop
        ? mobilePriceTypogragraphy.savings
        : desktopPriceTypography.savings;
    const typography = typographyMap[props.size || 'base'];
    return (0, styled_components_1.css)({
        fontFamily: typography.fontFamily,
        fontStyle: typography.fontStyle,
        fontSize: typography.fontSize,
        fontWeight: typography.fontWeight,
        lineHeight: typography.lineHeight
    });
};
const setPriceDetailsTypography = (props) => {
    const typographyMap = props.deviceType === monera_app_core_1.DeviceType.Mobile || props.deviceType === monera_app_core_1.DeviceType.MShop
        ? mobilePriceTypogragraphy.priceDetails
        : desktopPriceTypography.priceDetails;
    const typography = typographyMap[props.size || 'base'];
    return (0, styled_components_1.css)({
        fontFamily: typography.fontFamily,
        fontStyle: typography.fontStyle,
        fontSize: typography.fontSize,
        fontWeight: typography.fontWeight,
        lineHeight: typography.lineHeight
    });
};
exports.PriceContainer = styled_components_1.default.div `
  display: block;
`;
exports.PriceSpan = (0, styled_components_1.default)(themed_text_1.ThemedSpan) `
  && {
    ${setContainerHeight}
  }
`;
exports.PercentSavings = (0, styled_components_1.default)(themed_text_1.ThemedSpan) `
  && {
    color: ${(props) => props.theme.palettes.alert.error};
    padding-right: ${(props) => props.theme.spacings.mini};
    ${setSavingsTypography}
  }
`;
exports.PriceDetails = (0, styled_components_1.default)(themed_text_1.ThemedSpan) `
  && {
    display: inline-block;
    position: relative;
    width: fit-content;
    margin-top: ${(props) => props.theme.spacings.mini};
    ${setPriceDetailsTypography}
  }
`;
exports.OffScreenPrice = (0, styled_components_1.default)(themed_text_1.ThemedSpan) `
  user-select: none;
  position: absolute;
  left: 0;
  bottom: -1px;
  z-index: -1;
  opacity: 0;
`;
exports.SubsScriptPriceContainer = (0, styled_components_1.default)(themed_text_1.ThemedSpan) `
  position: relative;
`;
exports.PriceValueContainer = (0, styled_components_1.default)(themed_text_1.ThemedSpan) `
  && {
    padding-right: ${(props) => props.theme.spacings.mini};
  }
`;
exports.LeftCurrency = (0, styled_components_1.default)(themed_text_1.ThemedSpan) `
  && {
    position: relative;
    ${setRelativePosition}
  }
`;
exports.FractionalValue = (0, styled_components_1.default)(themed_text_1.ThemedSpan) `
  && {
    position: relative;
    ${setRelativePosition}
  }
`;
exports.RightCurrency = (0, styled_components_1.default)(themed_text_1.ThemedSpan) `
  && {
    padding-left: 0.2rem;
    position: relative;
    ${setRelativePosition}
  }
`;
exports.SubscriptionTerm = (0, styled_components_1.default)(themed_text_1.ThemedSpan) `
  && {
    margin-left: ${(props) => '-' + props.theme.spacings.mini};
    ${setSubscriptionTermStyle}
  }
`;
exports.PriceMessage = (0, styled_components_1.default)(themed_text_1.ThemedSpan) `
  && {
    margin-left: ${(props) => props.theme.spacings.mini};
    ${setPriceMessageStyle}
  }
`;
